export default __webpack_public_path__ + "static/media/suitcase_open.60fa0691.jpg";